import React from 'react';
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Paper from '@material-ui/core/Paper'
import Hidden from '@material-ui/core/Hidden';

const styles = (theme) => ({
  paper: {
    backgroundColor: theme.palette.background.default,
    padding: '1em',
    margin: '1em',
  },
})

const avatartalk = {
  width: 72,
  height: 72,
}
class MessageReceived extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <Grid container direction="row" item xs={12} cols={ 12 } spacing={2}>
        <Grid item xs={1}>
        <Hidden xsDown>
          <Avatar style={avatartalk} src={this.props.image} />
        </Hidden>
        </Grid>
        <Grid item xs={10}>
          <Paper className={classes.paper}>{this.props.text}</Paper>
        </Grid>
        <Grid item xs={1} />
      </Grid>
    )
  }
}

export default withStyles(styles)(MessageReceived)
